<template>
    <div
        class="doubts-table-page text-start"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <v-container class="p-0" fluid>
            <div class="page-card">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h1 class="card-title mb-2">Dúvidas</h1>
                        <p class="card-subtitle mb-4 mb-md-0">
                            Gerencie as dúvidas e perguntas frequentes do sistema.
                        </p>
                    </div>
                </div>
                <hr class="page-card__divider" />

                <v-row class="mt-1 mb-2" justify-sm="space-between">
                    <v-col cols="12" sm="8">
                        <v-text-field
                            v-model="searchText"
                            label="Pesquisar dúvida"
                            class="inputd"
                            variant="outlined"
                            density="compact"
                            hide-details
                            @update:model-value="onSearch"
                        >
                            <template v-slot:append-inner>
                                <Icon name="magnifyingGlass" size="20" />
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select
                            v-model="statusFilter"
                            :items="statusFilterOptions"
                            item-title="text"
                            item-value="value"
                            label="Status"
                            variant="outlined"
                            class="inputd"
                            @update:modelValue="filtrarDoubts"
                            density="compact"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <div data-aos="fade-up" data-aos-duration="1500">
                    <v-table class="custom-table">
                        <thead>
                            <tr>
                                <th class="doubts-table__title-column">Dúvida</th>
                                <th class="doubts-table__student-column">Aluno(a)</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Ver</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="doubt in paginatedDoubts" :key="doubt.id">
                                
                                <td class="doubts-table__title-column">
                                    {{ doubt.title }}
                                </td>
                                <td class="doubts-table__student-column">
                                    {{ doubt.nameUser.charAt(0).toUpperCase() + doubt.nameUser.slice(1) }}
                                </td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="getStatusColor(doubt.status)"
                                    >
                                        {{ getStatusText(doubt.status) }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="viewDoubt(doubt.id, doubt)"
                                        icon
                                        title="Ver Detalhes"
                                        variant="text"
                                    >
                                        <Icon name="eye" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>

                <v-responsive>
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="!hasReady"
                        @update:model-value="onPageChange"
                    ></v-pagination>
                </v-responsive>

                <Loader v-if="!hasReady" />
            </div>
        </v-container>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import ApiInquiry from '@/utils/inquiry';
import { debounce } from 'lodash';
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
    components: {
        Loader
    },
    data() {
        return {
            doubtsData: [],
            searchText: '',
            currentPage: 1,
            itemsPerPage: 10,
            hasReady: false,
            statusFilter: 'todos',
            statusFilterOptions: [
                { text: 'Todos', value: 'todos' },
                { text: 'Respondida', value: '1' },
                { text: 'Não Respondida', value: '0' }
            ],
        };
    },
    computed: {
        ...mapState(["token", "numberIntensTable"]),
        
        paginatedDoubts() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            return this.filteredDoubts.slice(startIndex, endIndex);
        },
        
        totalPages() {
            return Math.ceil(this.filteredDoubts.length / this.itemsPerPage);
        },
        
        filteredDoubts() {
            let filtered = this.doubtsData;

            if (this.searchText && this.searchText.trim() !== '') {
                filtered = filtered.filter((doubt) =>
                    doubt.title.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    doubt.nameUser.toLowerCase().includes(this.searchText.toLowerCase())
                );
            }
            
            if (this.statusFilter !== 'todos') {
                filtered = filtered.filter((doubt) => {
                    return doubt.status === parseInt(this.statusFilter);
                });
            }

            return filtered;
        }
    },
    created() {
        this.getListInquiry();
    },
    methods: {
        ...mapActions(['storeDoubt']),
        
        getStatusColor(status) {
            switch (status) {
                case 1: return 'success';
                case 0: return 'warning';
                case 9: return 'danger';
                default: return 'grey';
            }
        },
        
        getStatusText(status) {
            switch (status) {
                case 1: return 'Respondida';
                case 0: return 'Não Respondida';
                case 9: return 'Deletada';
                default: return 'Desconhecido';
            }
        },
        
        filtrarDoubts() {
            this.currentPage = 1;
        },
        
        viewDoubt(id, doubt) {
            this.storeDoubt({ doubt: doubt });
            this.$router.push('duvida/' + id);
        },
        
        async getListInquiry() {
            try {
                this.hasReady = false;
                const response = await ApiInquiry.getDataInquiry(this.token);
                this.doubtsData = response.map(doubt => {
                    const { ...rest } = doubt;
                    return rest;
                });
                this.hasReady = true;
            } catch (error) {
                toast.error('Erro ao carregar as dúvidas. Por favor, tente novamente.');
                console.error('Erro ao carregar as dúvidas', error);
            }
        },
        
        getIndexById(id) {
            const index = this.doubtsData.findIndex(doubt => doubt.id === id);
            return index + 1; 
        },
        
        onSearch: debounce(function () {
            this.currentPage = 1;
        }, 300),
        
        onPageChange() {
        }
    }
};
</script>

<style scoped>
@import '@/css/weeduc/admin/faq.css';

</style>